import { render, staticRenderFns } from "./ListItemDistinguisher.vue?vue&type=template&id=c88cbf7c&"
import script from "./ListItemDistinguisher.vue?vue&type=script&lang=ts&"
export * from "./ListItemDistinguisher.vue?vue&type=script&lang=ts&"
import style0 from "./ListItemDistinguisher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports